import React, { useMemo } from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

interface Props {
    endTime: Date | string;
}

const useStyles = makeStyles({
    badge: {
        backgroundColor: "#FFF9C4",
        color: "#000",
        fontWeight: 500,
        fontSize: "0.75rem",
    },
});

export function MaintenanceModeBadge({ endTime }: Props) {
    const classes = useStyles();

    const tooltipTitle = useMemo(() => {
        const end = moment(endTime);
        const now = moment();
        const duration = moment.duration(end.diff(now));

        if (duration.asMilliseconds() <= 0) {
            return "Maintenance mode ending";
        }

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        let timeRemaining = "";
        if (hours === 0) {
            timeRemaining = `${minutes} minute${minutes !== 1 ? 's' : ''}`;
        } else if (minutes === 0) {
            timeRemaining = `${hours} hour${hours !== 1 ? 's' : ''}`;
        } else {
            timeRemaining = `${hours}h ${minutes}m`;
        }

        return `Maintenance mode - ${timeRemaining} remaining`;
    }, [endTime]);

    return (
        <Tooltip title={tooltipTitle}>
            <Chip
                label="Maintenance"
                size="small"
                className={classes.badge}
            />
        </Tooltip>
    );
}
